export const DEFAULT_COVER =
  "https://images.unsplash.com/photo-1603048588665-791ca8aea617?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwZGFyayUyMGFlc3RoZXRpYyUyMHZpbnlsJTIwcmVjb3JkfGVufDB8fHx8MTc4NjM3ODE5M3ww&ixlib=rb-4.1.0&q=85";

export function formatTime(sec) {
  if (!sec || isNaN(sec) || !isFinite(sec)) return "0:00";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function formatBytes(bytes) {
  if (!bytes) return "0 MB";
  const mb = bytes / (1024 * 1024);
  if (mb < 1024) return `${mb.toFixed(1)} MB`;
  return `${(mb / 1024).toFixed(2)} GB`;
}

export function bgStyle(bg) {
  if (!bg) return { backgroundColor: "#050505" };
  if (bg.type === "image" && bg.image) {
    return {
      backgroundImage: `url(${bg.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    };
  }
  if (bg.type === "gradient" && bg.gradient) {
    return { backgroundImage: bg.gradient };
  }
  return { backgroundColor: bg.color || "#050505" };
}
